import { appendStuCourseIds } from "../../../common/script/log-helper";

export function singleSelectPoint(
  type,
  key,
  selectCoursePackageInfo,
  stateUserId,
  discount = {}
) {
  /** 勾选才埋点 */
  if (selectCoursePackageInfo.selectType === 1) return;
  let params = appendStuCourseIds({
    user_id: stateUserId, // 用户id
    course_id: selectCoursePackageInfo?.courseId, // 课程id
    course_type: selectCoursePackageInfo?.saleType, // 课程类型
    grade_id: selectCoursePackageInfo?.courseInfo?.gradeIds, // 年级id
    subject_id: selectCoursePackageInfo?.courseInfo?.subjectIds, // 学科id
    edition_id: selectCoursePackageInfo?.courseInfo?.versionID, // 版本id
    difficulty_id: selectCoursePackageInfo?.courseInfo?.difficultyAlias, // 难度id
    category: selectCoursePackageInfo?.courseInfo?.category, // 上课方式
    teacher_type: selectCoursePackageInfo?.teacherInfo
      ?.map((item) => {
        return item.id;
      })
      .join(","), // 老师类型
    teacher_list: selectCoursePackageInfo?.teacherInfo
      ?.map((item) => {
        return item.typeName;
      })
      .join(","), // 老师id
    discount,
  });
  if (type) {
    // 真为点击，假为pv
    window.__XES_LOG__?.clickMsg({ key, params });
  } else {
    window.__XES_LOG__?.loadMsg({ key, params });
  }
}

export function sharePoint(stateUserId) {
  window.__XES_LOG__?.clickMsg({
    params: appendStuCourseIds({
      data_clickid: "1.2.1",
      user_id: stateUserId,
    }),
  });
}

export function selectAllPoint(click_type, stateSelectAll, stateUserId) {
  window.__XES_LOG__?.clickMsg({
    params: appendStuCourseIds({
      data_clickid: "1.2.5",
      choice_type: stateSelectAll ? "全选" : "取消全选",
      user_id: stateUserId,
      click_type: click_type,
    }),
  });
}

export function loadPoint(querySourceId, selectCourseIds, stateUserId) {
  window.__XES_LOG__.opts.param = {
    source_id: querySourceId,
  };
  window.__XES_LOG__?.loadMsg({
    params: appendStuCourseIds({
      data_pageid: "1.2.1",
      course_id: selectCourseIds,
      user_id: stateUserId,
    }),
  });
}
